export const SETREPORTPARAM = "SETREPORTPARAM";
